define('shared/util/checkout/member',[
        'shared/initializer/form/constants',
        'shared/lib/RSVP',
        'shared/lib/console',
        'shared/lib/URI'
    ],
    function (
        constants,
        RSVP,
        console,
        URI
    ) {
        'use strict';

        return {
            isUpdatingMemberInfo: function(){
                var uri = new URI(location.href);
                var query = uri.query(true);

                return ((uri.pathname().indexOf('thank') >= 0) || 
                    query[constants.QueryString.updateMemberInfo] === 'true');
            }
        };
    });
